import { useQuery } from '@tanstack/react-query';
import { getInspectionService } from '../../api/inspection-service.ts';
import { normalizeNulls } from '../../utils/normalizeNulls.ts';

export default function useInspectionService(
  serviceId: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ['inspectionServices', serviceId],
    queryFn: async () => {
      return await getInspectionService(serviceId);
    },
    select: normalizeNulls,
    enabled: !!serviceId && (options?.enabled ?? true),
  });
}
